import './stage.scss';

class JobDetailStage {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-job-detail-stage'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$jobDetailStage = $element;
        this.$jobDetail = document.querySelector('[data-job-detail="root"]');
        this.$siteHeader = document.querySelector('.siteheader__wrapper');
        this.$siteFooter = document.querySelector('.sitefooter');
        this.eventScroller = window.eventScroller;

        if (this.$jobDetail) {
            this.initialize();
        }
    }

    initialize () {
        this.$stickyStage = this.$jobDetailStage.cloneNode(true, true);
        this.$stickyStage.classList.add('job-detail-stage--sticky');
        this.$jobDetail.appendChild(this.$stickyStage);

        this.checkPagePosition();
        this.eventScroller.customFunctions.push(() => {
            this.checkPagePosition();
        });
    }

    checkPagePosition () {
        const stageBoundings = this.$jobDetailStage.getBoundingClientRect();
        const stageBottomPosition = stageBoundings.top + stageBoundings.height;
        const stickyStageBoundings = this.$stickyStage.getBoundingClientRect();
        const stickyStageHeight = stickyStageBoundings.height;
        let headerOffset = 0;

        if (this.$siteHeader) {
            headerOffset = this.$siteHeader.offsetHeight;
        }

        if (stageBottomPosition - headerOffset <= 0) {
            this.$stickyStage.classList.add('job-detail-stage--visible');
            this.updateUserCentrics(stickyStageHeight);

            if (this.$siteFooter) {
                const footerBoundings = this.$siteFooter.getBoundingClientRect();

                if (footerBoundings.top - window.innerHeight - (stickyStageHeight / 2) <= 0) {
                    this.$stickyStage.classList.remove('job-detail-stage--visible');
                    this.updateUserCentrics(0);
                } else {
                    this.$stickyStage.classList.add('job-detail-stage--visible');
                    this.updateUserCentrics(stickyStageHeight);
                }
            }
        } else {
            this.$stickyStage.classList.remove('job-detail-stage--visible');
            this.updateUserCentrics(0);
        }
    }

    updateUserCentrics (move) {
        const $usercentrics = document.getElementById('usercentrics-root');

        if ($usercentrics) {
            const $shadowRoot = $usercentrics.shadowRoot;
            const $button = $shadowRoot.querySelector('[data-testid="uc-privacy-button"]');

            if ($button) {
                $button.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
                if (move > 0) {
                    move = move * -1;
                }

                $button.style.transform = 'translateY(' + move + 'px)';
            }
        }
    }
}

export { JobDetailStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$jobDetailStage = $context.querySelectorAll('[data-job-detail-stage="root"]');
        for (let i = 0; i < $$jobDetailStage.length; i++) {
            const $jobDetailStage = $$jobDetailStage[i];

            const jobDetailStageAPI = new JobDetailStage($jobDetailStage);
            $jobDetailStage.API = jobDetailStageAPI;
        }
    }
});
